module.exports = __webpack_public_path__ + "img/bw1mapper.2ab1801a.svg";